module.exports = __webpack_public_path__ + "img/news.c94bfcc.2c2fe51f.png";